<template id="map-template">
  <div class="homeview-messagecenter-data">
    <div class="header">
      <span class="header-title">消息中心</span>
      <div class="arrow-pic"></div>
      <!-- <div class="icon-spread"></div> -->
    </div>
    <div class="table-chart">
      <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
        <el-table-column prop="AlertType" label="预警类型" :formatter="getAlarmTypeShow"></el-table-column>
        <el-table-column prop="BeginDate" label="预警时间" :formatter="formatDate"></el-table-column>
        <el-table-column prop="Content" label="预警信息">
          <template slot-scope="scope">
            <el-popover placement="top-start" title="预警信息" width="250" trigger="hover">
              <div>{{scope.row.Content}}</div>
              <span
                slot="reference"
              >{{ scope.row.Content.length>3?scope.row.Content.substr(0,3)+'...':scope.row.Content }}</span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="ProcessStatus" label="处理状态" :formatter="formatStatus"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "HomeViewMessageCenter",
  componentName: "HomeViewMessageCenter",
  components: {},
  props: {},
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      AlertType: null, //预警类型
      AlertTypeArr: [],
      AlerteLevel: null, //预警级别
      AlerteLevelArr: [],
    };
  },
  created() {
    //预警级别
    this.alarmLevel();
    //预警类型
    this.getAlarmType();
  },
  mounted: function () {
    this.search();
  },
  methods: {
    search() {
      let searchInfo = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        AlertType: this.AlertType,
        AlerteLevel: this.AlerteLevel,
        ProcessStatus: "0",
      };
      new MyApis.AlarmApi()
        .GetAlertItemPagingList(searchInfo)
        .then((r) => {
          //console.log("1");
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }

      return new Date(data).format("MM/dd hh:mm");
    },
    formatStatus(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == "0") return "待处理";
      else if (data == "2") return "已完结";
      return "";
    },
    getAlarmTypeShow(row,column){
      let data = row[column.property];
      console.log(data)
      if (data == null || data == "") {
        return null;
      }
     let arr = this.AlertTypeArr
     for(let i=0;i<arr.length;i++){
       if(arr[i].Extend1==data){
         return arr[i].Description
       }
     }
    },
    //基础数据绑定
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then((d) => {
          console.log("预警级别");
          console.log(d);
          this.AlerteLevelArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then((d) => {
          console.log("预警类型");
          console.log(d);
          this.AlertTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
  },
};

</script>